import './../scss/global.scss';
import { Accessibility } from './components/Accessibility';
import { CustomEditor } from './components/CustomEditor';
import { ContactForm } from './components/ContactForm';
import { Gallery } from './components/Gallery';
import { Menu } from './components/Menu';
import { MerlinForm } from './components/MerlinForm';
import { Quotes } from './components/Quotes';
import { VideoPlayer } from './components/VideoPlayer';
import { KeepAlive } from './handlers/KeepAlive';
import { WindowEventHandler } from './handlers/WindowEventHandler';

document.addEventListener('DOMContentLoaded', () => {
  new WindowEventHandler();// Call this first to set any global properties that can be used from here on.
  new Accessibility();
  new CustomEditor();
  if (document.documentElement.hasAttribute('data-keep-alive')) new KeepAlive();
  new Menu();
  new VideoPlayer();
  document.querySelectorAll('.contact-form').forEach(el => { new ContactForm(el, false); });
  document.querySelectorAll('.gallery-items').forEach(el => { new Gallery(el); });
  document.querySelectorAll('.merlinform').forEach(el => { new MerlinForm(el); });
  document.querySelectorAll('.quotes').forEach(el => { new Quotes(el); });
  document.documentElement.classList.remove('preload');
});
